export const NODE_W = 160;
export const NODE_H = 36;
export const FOLDER_W = 164;
export const FOLDER_H = 40;
export const ROOT_R = 32;

export const DEPTH_RADIUS = 280;
export const REPULSION    = -600;
export const LINK_DIST    = 220;
export const COLLISION_R  = 100;
export const SIM_TICKS    = 300;